export const MESSAGE_TYPE = {
    appLogout: "appLogout",
    getNextAction: "getNextAction",
    clearNextAction: "clearNextAction",
    nextActionUpdated: "nextActionUpdated",
    nextActionResponse: "nextActionResponse",
    getChromeStorageData: "getChromeStorageData",
    getChromeStorageDataResponse: "getChromeStorageDataResponse",
    openPopupSettings: "openPopupSettings",
} as const;

type MessageTypeT = keyof typeof MESSAGE_TYPE;

export type MessageT = {
    type: MessageTypeT
    data: any
};